var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "mt-5 text-center p-3 md_px-1 md_py-0 bg-brand-secondary-50 md_bg-transparent"
    },
    [
      _c("img", {
        staticClass: "opacity-100 w-4 mx-auto",
        attrs: { alt: "viralstyle mail in envelope", src: _vm.emailLogoImg }
      }),
      _c(
        "div",
        { staticClass: "text-4xl font-bold text-brand-secondary-900 mt-1" },
        [_vm._v("Get design inspiration and exclusive offers.")]
      ),
      _c(
        "div",
        {
          staticClass:
            "text-xl text-brand-secondary-850 md_text-brand-secondary-700 mt-1 md_mt-0"
        },
        [_vm._v("Sign up for exclusives & 15% off on your first purchase!")]
      ),
      _c("buyer-input", {
        staticClass: "max-w-lg mx-auto mt-2",
        attrs: {
          placeholder: "Your email address",
          type: "email-offers",
          "error-visible": _vm.submitted,
          error: _vm.validator.firstError("email"),
          value: _vm.email
        },
        on: { input: _vm.inputEmail, search: _vm.clickSend }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }